import { HttpContext, HttpContextToken } from '@angular/common/http';

export const SILENT_LOAD_CONTEXT = new HttpContextToken(() => false);

export function withSilentLoadContext() {
  return new HttpContext().set(SILENT_LOAD_CONTEXT, true);
}
